import { useEffect } from 'react';
/**
 * Hook that sets the theme in MeControl
 */
export const useThemeMeControlEffect = (isDarkMode) => {
    useEffect(() => {
        var _a, _b;
        // @ts-ignore
        if ((_b = (_a = window === null || window === void 0 ? void 0 : window.MeControl) === null || _a === void 0 ? void 0 : _a.API) === null || _b === void 0 ? void 0 : _b.setTheme) {
            // @ts-ignore
            window.MeControl.API.setTheme({
                type: isDarkMode ? 'dark' : 'light',
            });
        }
    }, [isDarkMode]);
};
